import 'd3';


function getColors (i) {
	var colorArray = [
		'#5CB85C',
		'#E5E5E5',
		'#b71c1c',
		'grey',
	];
	return colorArray[i];
}


function getLabel(d, i) {
	var labels = ['Accepted', 'No response', 'Declined'];
	if (d.data > 0) return labels[i];
	else return '';
}


export default function() {
	return {
		scope: {
			data: '<',
		},
		link: link,
	};

	function link(scope, element, attrs, ctrls) {
		var width = 500;
		var height = 300;
		var color = d3.scale.category20();

		var svg = d3.select(element[0])
			.attr('viewBox', '0 0 500 300')
			.attr('preserveAspectRatio', 'xMinYMin meet')
			.attr('width', '100%')
			.append('g')
			.attr('transform', 'translate(' + width/2 + ',' + height/2  + ')')

		scope.$watch('data', function(value) {
			build(scope, svg);
		});
	}

	function build(scope, svg) {
		var radius = 150;

		var data = [
			scope.data.accepted || 0,
			scope.data.could_not_reach || 0,
			scope.data.declined || 0,
		];

		var goodData = true;
		if (data[0] == 0 && data[1] == 0 && data[2] == 0) {
			goodData = false;
			data = [0, 0, 0, 1];
		}

		svg.selectAll('*').remove();

		svg.append('g')
			.attr('class', 'chart-labels');
		svg.append('g')
			.attr('class', 'lines');

		var arc = d3.svg.arc()
			.innerRadius(150 - 80)
			.outerRadius(150 - 20);
		var pie = d3.layout.pie().sort(null);

		var path = svg.selectAll('path')
			.data(pie(data))
			.enter()
			.append('path')
			.attr('fill', (d, i) => getColors(i))
			.attr('d', arc);

		if (goodData) {
			svg.append('text')
				.attr('dy', '.35em')
				.attr('text-anchor', 'middle')
				.attr('font-size','50')
				.attr('fill','#5CB85C')
				.text((data[0]/scope.data.total*100).toFixed(0) + '%');
		}

		var text = svg.select('.chart-labels').selectAll('text')
			.data(pie(data), getLabel);

		text.enter()
			.append('text')
			.attr('dy', '.35em')
			.text(getLabel);

		function midAngle(d){
			return d.startAngle + (d.endAngle - d.startAngle)/2;
		}

		var outerArc = d3.svg.arc()
			.innerRadius(radius*0.95)
			.outerRadius(radius*0.95);

		text.transition().duration(1000)
			.attrTween('transform', function(d) {
				this._current = this._current || d;
				var interpolate = d3.interpolate(this._current, d);
				this._current = interpolate(0);
				return function(t) {
					var d2 = interpolate(t);
					var pos = outerArc.centroid(d2);
					pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
					return 'translate('+ pos +')';
				};
			})
			.styleTween('text-anchor', function(d){
				this._current = this._current || d;
				var interpolate = d3.interpolate(this._current, d);
				this._current = interpolate(0);
				return function(t) {
					var d2 = interpolate(t);
					return midAngle(d2) < Math.PI ? 'start':'end';
				};
			});

		text.exit()
			.remove();

		/* ------- SLICE TO TEXT POLYLINES -------*/

		var polyline = svg.select('.lines').selectAll('polyline')
			.data(pie(data), getLabel);

		polyline.enter()
			.append('polyline')
			.attr('class', function(d, i) {
				if (d.data == 0) {
					return 'hidden';
				} else {
					return '';
				}
			});

		polyline.transition().duration(1000)
			.attrTween('points', function(d){
				this._current = this._current || d;
				var interpolate = d3.interpolate(this._current, d);
				this._current = interpolate(0);
				return function(t) {
					var d2 = interpolate(t);
					var pos = outerArc.centroid(d2);
					pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
					return [arc.centroid(d2), outerArc.centroid(d2), pos];
				};			
			});

		polyline.exit()
			.remove();
	}
}
